import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import PayoutItemContent from './PayoutItemContent/PayoutItemContent.container';

const PayoutItemPage = ({ t }) => {
    const staticNames = t?.payoutItemPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <PayoutItemContent />
            </section>
        </React.Fragment>
    );
};

PayoutItemPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(PayoutItemPage);
